module.exports = __webpack_public_path__ + "img/separator12.a30b015b.svg";